import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { type CafeteriaSettings, cafeteriaSettingsApi } from '../settings';

const settingsKey = ['cafeteria', 'settings'] as const;

export function useCafeteriaSettingsQuery() {
  return useQuery({
    queryKey: settingsKey,
    queryFn: () => cafeteriaSettingsApi.get(),
  });
}

export function useUpdateCafeteriaSettingsMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CafeteriaSettings) => cafeteriaSettingsApi.update(input),
    onSuccess: data => qc.setQueryData(settingsKey, data),
  });
}
